// @flow

import type { State } from './types';

type GlobalState = {
  blogSettings: State,
};

export const getBlogSettings = (state: GlobalState): State => {
  const { blogSettings } = state;
  if (!blogSettings) {
    throw new Error('Missing blogSettings store.');
  }
  return blogSettings;
};

type BlogOverviewLink = $PropertyType<State, 'blog_overview_link'>;
export const getBlogOverviewLink = (state: GlobalState): BlogOverviewLink => (
  getBlogSettings(state).blog_overview_link
);

type BlogOverviewLinkLabel = $PropertyType<State, 'blog_overview_link_label'>;
export const getBlogOverviewLinkLabel = (state: GlobalState): BlogOverviewLinkLabel => (
  getBlogSettings(state).blog_overview_link_label
);

type BlogReadMoreLabel = $PropertyType<State, 'read_more_label'>;
export const getBlogReadMoreLabel = (state: GlobalState): BlogReadMoreLabel => (
  getBlogSettings(state).read_more_label
);

type BlogLatestArticlesLabel = $PropertyType<State, 'latest_articles_label'>;
export const getBlogLatestArticlesLabel = (state: GlobalState): BlogLatestArticlesLabel => (
  getBlogSettings(state).latest_articles_label
);

type BlogShareLabel = $PropertyType<State, 'share_label'>;
export const getBlogShareLabel = (state: GlobalState): BlogShareLabel => (
  getBlogSettings(state).share_label
);

type BlogLoadMoreLabel = $PropertyType<State, 'load_more_label'>;
export const getBlogLoadMoreLabel = (state: GlobalState): BlogLoadMoreLabel => (
  getBlogSettings(state).load_more_label
);

export default null;
